import { listConnections } from '@/data/queries'
import { useAsync } from '@/data/useAsync'
import { Card, Failed, Loading } from '@/components/bits'
import { timeOfDay } from '@/lib/format'

export function Planday() {
  const result = useAsync(() => listConnections(), [])

  if (result.state === 'loading') return <Loading what="the Planday connections" />
  if (result.state === 'error') return <Failed message={result.message} onRetry={result.reload} />

  return (
    <div className="screen">
      <Card title="Planday connections" flush>
        <div className="tablewrap">
          <table>
            <thead>
              <tr>
                <th>Portal</th>
                <th>Name</th>
                <th>Last success</th>
                <th className="r">Seen</th>
                <th className="r">Changed</th>
                <th className="r">Skipped</th>
                <th className="r">Failed</th>
                <th>Writes</th>
              </tr>
            </thead>
            <tbody>
              {result.data.map((c) => (
                <tr key={c.organisationCode}>
                  <td className="mono">{c.organisationCode}</td>
                  <td className="name">{c.displayName ?? '—'}</td>
                  <td className="mono">{timeOfDay(c.lastSuccessAt)}</td>
                  <td className="r mono">{c.lastRun?.seen ?? '—'}</td>
                  <td className="r mono">{c.lastRun?.changed ?? '—'}</td>
                  <td className="r mono">{c.lastRun?.skipped ?? '—'}</td>
                  <td className="r mono">{c.lastRun?.failed ?? '—'}</td>
                  <td>
                    <span className={c.allowWrites ? 'status active' : 'status terminated'}>
                      {c.allowWrites ? 'Allowed' : 'Off'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={{ padding: '16px 18px', borderTop: '1px solid var(--line-soft)' }}>
          <div className="callout">
            <strong>Seen equals changed plus unchanged plus skipped.</strong> If those do not add
            up, a record went somewhere unaccounted for and the sync needs looking at rather than
            trusting.
          </div>
          <div className="callout" style={{ borderLeftColor: 'var(--sev-critical)' }}>
            <strong>Deactivation is still blocked.</strong> No endpoint our credentials can reach
            sets a Planday deactivation date. Until Planday support says which request{' '}
            <span className="mono">employee:deactivate</span> actually authorises, leaver dates are
            held here and written by hand in Planday.
          </div>
        </div>
      </Card>
    </div>
  )
}
